<template>
    <div>
        <button id="accordionId" class="race-course-dropdown race-course-dropdown-header" v-on:click="onAccordionClicked(raceCourses.id)">
            <img class="race-course-option-img" :src="getImage(raceCourses.selected.countryFlagPath)">
            <div class="race-course-course-name">
                {{raceCourses.selected.courseName}}
            </div>
            <img class="race-course-option-header-arrow" :src="getImage('fixtures-dropdown-icon')">
        </button>
        <div :id="raceCourses.id" class="collapse accordion-body">
            <button id="accordionId" class="race-course-dropdown race-course-dropdown-option text" v-on:click="onResultsClicked()">
                Results
            </button>
            <button id="accordionId" class="race-course-dropdown race-course-dropdown-option text" v-on:click="onRaceCardClicked()">
                Racecard
            </button>
            <button id="accordionId" class="race-course-dropdown race-course-dropdown-option text"  v-on:click="onCardChangesClicked()">
                Card Changes
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Accordion',
        props: {
            raceCourses: Object,
            accordionId: Number
        },
        methods: {
            getImage(imagePath) {
                return require('../assets/images/' + imagePath + '.svg');
            },
            onAccordionClicked(accordionId) {
                document.querySelector(`#${accordionId}`).classList.toggle('collapse');
                document.querySelectorAll(`#${this.accordionId}`).forEach((element) =>
                    element.classList.toggle('race-course-dropdown-focus')
                );
            },
            onResultsClicked() {
                this.$router.push('/landing/results');
            },
            onRaceCardClicked() {
                this.$router.push('/landing/racecard');
            },
            onCardChangesClicked() {
                this.$router.push('/landing/cardchanges');
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .accordion-body  {
        position: absolute;
        width: 100%;
        z-index: 10;
    }

    .race-course-dropdown-header {
        position: relative;
        font-size: 1.8rem;
        font-weight: bolder;
        background-color: #FFFFFF;
        color: #000000;
        border: solid 1px #000000;
    }

    .race-course-dropdown-option {
        font-size: 1.3rem;
        background-color: #000000;
        border: solid 1px #FFFFFF;
        padding: 0.6rem 0 0.6rem 0;
        margin-bottom: 0.3rem;
    }

    .race-course-dropdown {
        opacity: 0.9;
        width: 90%;
        text-align: center;
        border-radius: 5px;
        box-shadow: 0 10px 12px -4px black;
    }

    .race-course-dropdown:hover {
        cursor: pointer;
    }

    .race-course-dropdown:focus {
        outline:0;
    }

    .race-course-dropdown-focus {
        background-color: #000000;
    }

    .race-course-course-name {
        font-size: 1.3rem;
        position: absolute;
        left: 50%;
        text-align: center;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .race-course-option-img {
        width: 45px;
        float: left;
    }

    .race-course-dropdown-option:hover {
        opacity: 1 !important;
        background-color: #000000 !important;
    }

    .race-course-option-header-arrow {
        width: 45px;
        float: right;
    }

    button:hover {
        background-color: #F0F0F0;
    }
</style>
